var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTurnDevice = function SvgTurnDevice(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.38 55.76-2.384.145 3.445-6.903 4.257 6.435-2.318.14c2.748 20.8 20.548 36.421 41.62 36.421h.5v3H50c-22.668 0-41.768-16.836-44.62-39.238M91.62 44.423C88.872 23.623 71.073 8.002 50 8.002h-.5v-3h.5c22.67 0 41.77 16.834 44.621 39.239l2.383-.145-3.445 6.903-4.256-6.436z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.653,
    height: 65.653,
    x: 30.174,
    y: 17.173,
    stroke: "#fff",
    strokeWidth: 4.347,
    rx: 5.071
  })));
};
export default SvgTurnDevice;